var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex w-40 rounded-full mb-2 overflow-hidden" },
    [_c("Skeleton", { attrs: { width: 180, height: 26 } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }